import React from 'react'
import { buildPropTypes, pt } from 'common-data/proptypehelpers'
import { Grid } from './Grid'
import { GridCell } from './GridCell'
import { Button } from './Button'
import clsx from 'clsx'
import _ from 'common-tools/LodashHelper'
import { FAIcon } from './FAIcon'
import styles from './WizardBox.less'

export const WizardBoxSteps = {
  Done: 'done',
  Cancel: 'cancel'
}

export class WizardBoxItem extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    children: pt.any,
    stepId: pt.string.isRequired,
    nextStepId: pt.string.isRequired,
    previousStepId: pt.string,
    icon: pt.string.isRequired,
    hideNextStepButton: pt.bool.isRequired
  })

  static defaultProps = {
    icon: 'building',
    hideNextStepButton: false
  }

  render () {
    const { children } = this.props
    return children
  }
}

export class WizardBox extends React.Component {
  constructor (props) {
    super(props)

    const { defaultStepId, children } = props

    this.state = {
      activeStep: defaultStepId,
      allSteps: _.map(children, (c) => {
        return c.props
      }),
      completedSteps: [
        defaultStepId
      ]
    }
  }

  static propTypes = buildPropTypes([

  ], {
    children: pt.oneOfType([pt.arrayOf(pt.element), pt.element]),
    defaultStepId: pt.string.isRequired
  })

  static defaultProps = {
    defaultStepId: '1'
  }

  async toggle (stepId, direction) {
    const { beforeStepAction, afterStepAction } = this.props
    const { completedSteps, activeStep } = this.state

    if (activeStep !== stepId) {
      if (_.isFunction(beforeStepAction)) {
        if (await beforeStepAction(stepId, activeStep, direction, completedSteps)) {
          return // abort step
        }
      }
      if (stepId !== WizardBoxSteps.Cancel) {
        this.setState({
          activeStep: stepId,
          completedSteps: _.concat(completedSteps, stepId)
        }, async () => {
          if (_.isFunction(afterStepAction)) {
            await afterStepAction(stepId, activeStep, direction, completedSteps)
          }
        })
      }
    }
  }

  getItems (items) {
    const ret = {
      navs: [],
      steps: []
    }
    const { testId } = this.props
    const { activeStep, completedSteps } = this.state
    if (_.isArray(items)) {
      _.forEach(items, (item, i) => {
        ret.navs.push(
          <li data-tid={`${testId}-${item.props.stepId}-nav`} key={item.props.stepId} className={clsx('tabs-title', activeStep === item.props.stepId ? 'is-active' : _.indexOf(completedSteps, item.props.stepId) > -1 ? 'is-active' : '')}>
            <a href="#" onClick={_.indexOf(completedSteps, item.props.stepId) > -1 ? () => { this.toggle(item.props.stepId, 'previous') } : null} aria-selected={activeStep === item.props.stepId ? 'true' : undefined}><FAIcon size='35px' name={item.props.icon || 'plus'} /></a>
          </li>
        )
        ret.steps.push(
          <div data-tid={`${testId}-${item.props.stepId}-tab`} key={item.props.stepId} className={clsx('tabs-panel', activeStep === item.props.stepId && 'is-active')}>
            {item.props.children}
          </div>
        )
      })
    }

    ret.navs.unshift(
      <li data-tid={`${testId}-${WizardBoxSteps.Cancel}-nav`} key={WizardBoxSteps.Cancel} className={clsx('tabs-title')}>
        <a href="#" onClick={() => { this.toggle(WizardBoxSteps.Cancel, 'previous') } }> <FAIcon size='25px' name={'times'} /></a>
      </li>
    )

    return ret
  }

  renderStepAction (action) {
    const { hideNextStepButton, noFinalStepButton, testId } = this.props
    const { activeStep, allSteps } = this.state

    const matchStep = _.find(allSteps, { stepId: activeStep })

    if (!matchStep) {
      return null
    }

    switch (action) {
      case 'next':
        if (matchStep.nextStepId === WizardBoxSteps.Done) {
          if (noFinalStepButton === true) {
            return null
          } else {
            return <Button data-tid={`${testId}-wizardNext`} onClick={() => { this.toggle(matchStep.nextStepId, action) }}>
              <FAIcon size='35px' name='arrow-right' />
            </Button>
          }
        } else {
          if (matchStep.nextStepId) {
            if (hideNextStepButton === true) {
              return <Button outline>
                <FAIcon size='35px' name='times' toolTip='Thou shalt not pass!' />
              </Button>
            } else {
              return <Button data-tid={`${testId}-wizardNext`} onClick={() => { this.toggle(matchStep.nextStepId, action) }}>
                <FAIcon size='35px' name='arrow-right' />
              </Button>
            }
          } else {
            return <Button data-tid={`${testId}-wizardNext`}>
              <FAIcon size='35px' name='question' toolTip='I think you forgot to define a next step!' />
            </Button>
          }
        }
      case 'previous':
        if (matchStep.previousStepId) {
          return <Button outline data-tid={`${testId}-wizardPrev`} onClick={() => { this.toggle(matchStep.previousStepId, action) }}>
            <FAIcon name='arrow-left' size='35px' />
          </Button>
        }
        break
      default:
        return null
    }
  }

  render () {
    const { children } = this.props
    const items = this.getItems(children)

    return (
      <Grid vertical frame className={styles.wizard}>
        <GridCell shrink>
          <ul className='tabs'>
            {items.navs}
          </ul>
        </GridCell>
        <GridCell auto className='tabs-content'>
          <Grid vertical frame>
            <GridCell blockY>
              {items.steps}
            </GridCell>
          </Grid>
        </GridCell>
        <GridCell className='text-center' shrink>
          {this.renderStepAction('previous')}
          {this.renderStepAction('next')}
        </GridCell>
      </Grid>
    )
  }
}
